import { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { LogoSVG } from './ui/FormControls';
import { descargasEfectivas } from '../utils/cuotaFree';

const ENLACES_FREE = [
  { slug: "carretillas", label: "Carretillas elevadoras" },
  { slug: "transpaletas", label: "Transpaletas" },
  { slug: "mantenimiento", label: "Mantenimiento instalaciones" },
  { slug: "flota", label: "Flota" },
  { slug: "vehiculo-expres", label: "Vehículo Exprés" },
  { slug: "ajustes", label: "Mi cuenta" },
];

// ── Layout propio del plan FREE — sin Nav.js de tenant ───────────
export const FreeLayout = ({ setCurrentUser, setLoginUser, setLoginPass }) => {
  const navigate = useNavigate();
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [descargasUsadas, setDescargasUsadas] = useState(0);

  useEffect(() => {
    const cargarCuenta = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const user = session?.user;
      if (!user) return;
      const { data } = await supabase.from('cuentas').select('nombre_empresa, descargas_mes_actual, descargas_mes_reset').eq('user_id', user.id).maybeSingle();
      setNombreEmpresa(data?.nombre_empresa || "");
      setDescargasUsadas(descargasEfectivas(data));
    };
    cargarCuenta();
  }, []);

  const cerrarSesion = async () => {
    await supabase.auth.signOut({ scope: "local" });
    setCurrentUser(null);
    setLoginUser("");
    setLoginPass("");
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="text-white px-4 py-3 shadow" style={{ background: "linear-gradient(90deg,#0f172a,#1e3a5f)" }}>
        <div className="flex items-center justify-between max-w-3xl mx-auto">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(145deg,#0ea5e9,#0369a1)" }}>
              <LogoSVG size={20} />
            </div>
            <div>
              <h1 className="font-black text-lg leading-tight">Ware<span style={{ color: "#38bdf8" }}>Hause</span><span style={{ color: "#4ade80" }}>Plan</span></h1>
              {nombreEmpresa && <p className="text-blue-300 text-xs">{nombreEmpresa}</p>}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs px-2 py-1 rounded-full font-semibold bg-green-600">🆓 Plan Free</span>
            <button onClick={cerrarSesion} className="text-xs text-blue-300 hover:text-white px-2">⏻</button>
          </div>
        </div>
      </div>

      <div className="bg-white border-b px-4 py-2 shadow-sm sticky top-0 z-10">
        <div className="flex gap-2 max-w-3xl mx-auto overflow-x-auto pb-1">
          <NavLink to="/app/free/inicio" className={({ isActive }) => `px-3 py-2 text-xs font-semibold rounded-lg transition-all whitespace-nowrap ${isActive ? "bg-blue-600 text-white shadow" : "bg-white text-gray-600 hover:bg-blue-50 border border-gray-200"}`}>Inicio</NavLink>
          {ENLACES_FREE.map(({ slug, label }) => (
            <NavLink key={slug} to={`/app/free/${slug}`} className={({ isActive }) => `px-3 py-2 text-xs font-semibold rounded-lg transition-all whitespace-nowrap ${isActive ? "bg-blue-600 text-white shadow" : "bg-white text-gray-600 hover:bg-blue-50 border border-gray-200"}`}>{label}</NavLink>
          ))}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-4">
        <Outlet context={{ nombreEmpresa, descargasUsadas }} />
      </div>
    </div>
  );
};
